<script lang="ts">import Link from '../../../shared/Link/Link.svelte';
import ButtonLink from '../../../../PublicWebNav/ButtonLink/ButtonLink.svelte';
import { ctaSubnavButtonsAreVisibleStore } from '../../../../../js-v2/stores/desktop-cta-subnav-stores';
const { primaryCtaButton = undefined, secondaryCtaButton = undefined, ctaButtonStyleV1 = false, } = $props();
const ctaItems = [secondaryCtaButton, primaryCtaButton].filter((item) => item !== undefined);
</script>

{#if ctaItems.length > 0}
  <div class="global-nav-ctas" class:isVisible={!$ctaSubnavButtonsAreVisibleStore}>
    {#each ctaItems as cta}
      {#if cta}
        {#if ctaButtonStyleV1}
          <ButtonLink
            id={cta?.contentfulEntryId}
            title={cta?.props?.title}
            url={cta?.props?.url}
            linkStyle={cta?.props?.linkStyle}
            icon={cta?.props?.icon}
          />
        {:else}
          <Link
            id={cta?.contentfulEntryId}
            title={cta?.props?.title}
            url={cta?.props?.url}
            linkStyle={cta?.props?.linkStyle}
            icon={cta?.props?.icon}
            openInNewTab={cta?.props?.openInNewTab}
          />
        {/if}
      {/if}
    {/each}
  </div>

  <style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.global-nav-ctas {
  margin-left: 12px;
  display: none;
  gap: 12px;
  margin-right: 6px;
}
.global-nav-ctas.isVisible {
  display: flex;
}
@media (max-width: 79.9375rem) {
  .global-nav-ctas.isVisible {
    display: none;
  }
}
.global-nav-ctas .Link--button {
  white-space: nowrap;
}</style>
{/if}
